import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'footer-usage',
  templateUrl: './footer-usage.component.html',
  styleUrls: ['./footer-usage.component.sass']
})
export class FooterUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
